import "../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { renderImageIcon as S, renderDocumentIcon as j } from "./icons.js";
import { uploadInjectionKey as q } from "./interface.js";
import F from "./UploadProgress.js";
import { isImageFile as M } from "./utils.js";
import A from "../../../../../../vooks@0.2.12_vue@3.5.18/node_modules/vooks/es/use-memo.js";
import c from "../../_internal/icon/src/Icon.js";
import L from "../../image/src/Image.js";
import E from "../../_internal/icons/Attach.js";
import y from "../../button/src/Button.js";
import z from "../../_internal/icons/Eye.js";
import K from "../../_internal/icon-switch-transition/src/IconSwitchTransition.js";
import G from "../../_internal/icons/Trash.js";
import H from "../../_internal/icons/Cancel.js";
import J from "../../_internal/icons/Retry.js";
import Q from "../../_internal/icons/Download.js";
import { warn as V } from "../../_utils/naive/warn.js";
import { defineComponent as W, inject as X, computed as h, watchEffect as Y, h as n } from "../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
import { ref as T } from "../../../../../../@vue_reactivity@3.5.18/node_modules/@vue/reactivity/dist/reactivity.esm-bundler.js";
import { download as Z } from "../../_utils/dom/download.js";
var B = globalThis && globalThis.__awaiter || function(e, i, l, r) {
  function f(s) {
    return s instanceof l ? s : new l(function(a) {
      a(s);
    });
  }
  return new (l || (l = Promise))(function(s, a) {
    function w(d) {
      try {
        m(r.next(d));
      } catch (p) {
        a(p);
      }
    }
    function v(d) {
      try {
        m(r.throw(d));
      } catch (p) {
        a(p);
      }
    }
    function m(d) {
      d.done ? s(d.value) : f(d.value).then(w, v);
    }
    m((r = r.apply(e, i || [])).next());
  });
};
const R = {
  paddingMedium: "0 3px",
  heightMedium: "24px",
  iconSizeMedium: "18px"
}, Re = W({
  name: "UploadFile",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    file: {
      type: Object,
      required: !0
    },
    listType: {
      type: String,
      required: !0
    },
    index: {
      type: Number,
      required: !0
    }
  },
  setup(e) {
    const i = X(q), l = T(null), r = T(""), f = h(() => {
      const {
        file: t
      } = e;
      return t.status === "finished" ? "success" : t.status === "error" ? "error" : "info";
    }), s = h(() => {
      const {
        file: t
      } = e;
      if (t.status === "error")
        return "error";
    }), a = h(() => {
      const {
        file: t
      } = e;
      return t.status === "uploading";
    }), w = h(() => {
      if (!i.showCancelButtonRef.value)
        return !1;
      const {
        file: t
      } = e;
      return ["uploading", "pending", "error"].includes(t.status);
    }), v = h(() => {
      if (!i.showRemoveButtonRef.value)
        return !1;
      const {
        file: t
      } = e;
      return ["finished"].includes(t.status);
    }), m = h(() => {
      if (!i.showDownloadButtonRef.value)
        return !1;
      const {
        file: t
      } = e;
      return ["finished"].includes(t.status);
    }), d = h(() => {
      if (!i.showRetryButtonRef.value)
        return !1;
      const {
        file: t
      } = e;
      return ["error"].includes(t.status);
    }), p = A(() => r.value || e.file.thumbnailUrl || e.file.url), C = h(() => {
      if (!i.showPreviewButtonRef.value)
        return !1;
      const {
        file: {
          status: t
        },
        listType: o
      } = e;
      return ["finished"].includes(t) && p.value && o === "image-card";
    });
    function k() {
      return B(this, void 0, void 0, function* () {
        const t = i.onRetryRef.value;
        t && (yield t({
          file: e.file
        })) === !1 || i.submit(e.file.id);
      });
    }
    function P(t) {
      t.preventDefault();
      const {
        file: o
      } = e;
      ["finished", "pending", "error"].includes(o.status) ? b(o) : ["uploading"].includes(o.status) ? U(o) : V("upload", "The button clicked type is unknown.");
    }
    function x(t) {
      t.preventDefault(), O(e.file);
    }
    function b(t) {
      const {
        xhrMap: o,
        doChange: u,
        onRemoveRef: {
          value: g
        },
        mergedFileListRef: {
          value: D
        }
      } = i;
      Promise.resolve(g ? g({
        file: Object.assign({}, t),
        fileList: D,
        index: e.index
      }) : !0).then(($) => {
        if ($ === !1)
          return;
        const N = Object.assign({}, t, {
          status: "removed"
        });
        o.delete(t.id), u(N, void 0, {
          remove: !0
        });
      });
    }
    function O(t) {
      const {
        onDownloadRef: {
          value: o
        },
        customDownloadRef: {
          value: u
        }
      } = i;
      Promise.resolve(o ? o(Object.assign({}, t)) : !0).then((g) => {
        g !== !1 && (u ? u(Object.assign({}, t)) : Z(t.url, t.name));
      });
    }
    function U(t) {
      const {
        xhrMap: o
      } = i, u = o.get(t.id);
      u == null || u.abort(), b(Object.assign({}, t));
    }
    function I(t) {
      const {
        onPreviewRef: {
          value: o
        }
      } = i;
      if (o)
        o(e.file, {
          event: t
        });
      else if (e.listType === "image-card") {
        const {
          value: u
        } = l;
        if (!u)
          return;
        u.click();
      }
    }
    const _ = () => B(this, void 0, void 0, function* () {
      const {
        listType: t
      } = e;
      t !== "image" && t !== "image-card" || i.shouldUseThumbnailUrlRef.value(e.file) && (r.value = yield i.getFileThumbnailUrlResolver(e.file));
    });
    return Y(() => {
      _();
    }), {
      mergedTheme: i.mergedThemeRef,
      progressStatus: f,
      buttonType: s,
      showProgress: a,
      disabled: i.mergedDisabledRef,
      showCancelButton: w,
      showRemoveButton: v,
      showDownloadButton: m,
      showRetryButton: d,
      showPreviewButton: C,
      mergedThumbnailUrl: p,
      shouldUseThumbnailUrl: i.shouldUseThumbnailUrlRef,
      renderIcon: i.renderIconRef,
      imageRef: l,
      handleRemoveOrCancelClick: P,
      handleDownloadClick: x,
      handleRetryClick: k,
      handlePreviewClick: I
    };
  },
  render() {
    const {
      clsPrefix: e,
      mergedTheme: i,
      listType: l,
      file: r,
      renderIcon: f
    } = this;
    let s;
    const a = l === "image";
    a || l === "image-card" ? s = !this.shouldUseThumbnailUrl(r) || !this.mergedThumbnailUrl ? n("span", {
      class: `${e}-upload-file-info__thumbnail`
    }, f ? f(r) : M(r) ? n(c, {
      clsPrefix: e
    }, {
      default: S
    }) : n(c, {
      clsPrefix: e
    }, {
      default: j
    })) : n("a", {
      rel: "noopener noreferer",
      target: "_blank",
      href: r.url || void 0,
      class: `${e}-upload-file-info__thumbnail`,
      onClick: this.handlePreviewClick
    }, l === "image-card" ? n(L, {
      src: this.mergedThumbnailUrl || void 0,
      previewSrc: r.url || void 0,
      alt: r.name,
      ref: "imageRef"
    }) : n("img", {
      src: this.mergedThumbnailUrl || void 0,
      alt: r.name
    })) : s = n("span", {
      class: `${e}-upload-file-info__thumbnail`
    }, f ? f(r) : n(c, {
      clsPrefix: e
    }, {
      default: () => n(E, null)
    }));
    const v = n(F, {
      show: this.showProgress,
      percentage: r.percentage || 0,
      status: this.progressStatus
    }), m = l === "text" || l === "image";
    return n("div", {
      class: [`${e}-upload-file`, `${e}-upload-file--${this.progressStatus}-status`, r.url && r.status !== "error" && l !== "image-card" && `${e}-upload-file--with-url`, `${e}-upload-file--${l}-type`]
    }, n("div", {
      class: `${e}-upload-file-info`
    }, s, n("div", {
      class: `${e}-upload-file-info__name`
    }, m && (r.url && r.status !== "error" ? n("a", {
      rel: "noopener noreferer",
      target: "_blank",
      href: r.url || void 0,
      onClick: this.handlePreviewClick
    }, r.name) : n("span", {
      onClick: this.handlePreviewClick
    }, r.name)), a && v), n("div", {
      class: [`${e}-upload-file-info__action`, `${e}-upload-file-info__action--${l}-type`]
    }, this.showPreviewButton ? n(y, {
      key: "preview",
      quaternary: !0,
      type: this.buttonType,
      onClick: this.handlePreviewClick,
      theme: i.peers.Button,
      themeOverrides: i.peerOverrides.Button,
      builtinThemeOverrides: R
    }, {
      icon: () => n(c, {
        clsPrefix: e
      }, {
        default: () => n(z, null)
      })
    }) : null, (this.showRemoveButton || this.showCancelButton) && !this.disabled && n(y, {
      key: "cancelOrTrash",
      theme: i.peers.Button,
      themeOverrides: i.peerOverrides.Button,
      quaternary: !0,
      builtinThemeOverrides: R,
      type: this.buttonType,
      onClick: this.handleRemoveOrCancelClick
    }, {
      icon: () => n(K, null, {
        default: () => this.showRemoveButton ? n(c, {
          clsPrefix: e,
          key: "trash"
        }, {
          default: () => n(G, null)
        }) : n(c, {
          clsPrefix: e,
          key: "cancel"
        }, {
          default: () => n(H, null)
        })
      })
    }), this.showRetryButton && !this.disabled && n(y, {
      key: "retry",
      quaternary: !0,
      type: this.buttonType,
      onClick: this.handleRetryClick,
      theme: i.peers.Button,
      themeOverrides: i.peerOverrides.Button,
      builtinThemeOverrides: R
    }, {
      icon: () => n(c, {
        clsPrefix: e
      }, {
        default: () => n(J, null)
      })
    }), this.showDownloadButton ? n(y, {
      key: "download",
      quaternary: !0,
      type: this.buttonType,
      onClick: this.handleDownloadClick,
      theme: i.peers.Button,
      themeOverrides: i.peerOverrides.Button,
      builtinThemeOverrides: R
    }, {
      icon: () => n(c, {
        clsPrefix: e
      }, {
        default: () => n(Q, null)
      })
    }) : null)), !a && v);
  }
});
export {
  Re as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/upload/src/UploadFile.js
// module id = 1721
// module chunks = 41